import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tag from '~/components/atoms/Editorial/Tag.vue';
export default {
  name: 'TagList',
  components: {
    Tag: Tag
  },
  props: {
    tagList: {
      type: Array,
      required: true
    },
    isNuxtLink: {
      type: Boolean,
      default: false
    }
  }
};